/* eslint-disable */
import GraphQL from '../../../../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateDefaultSendingOfAlertsAndReportsToUserMutationVariables = GraphQL.Exact<{
  userId: GraphQL.Scalars['UserId']['input'];
  accountId: GraphQL.Scalars['AccountId']['input'];
  websites: ReadonlyArray<GraphQL.UpdateDefaultSendingOfAlertsAndReportsToUserWebsite> | GraphQL.UpdateDefaultSendingOfAlertsAndReportsToUserWebsite;
}>;


export type UpdateDefaultSendingOfAlertsAndReportsToUserMutation = { readonly __typename?: 'Mutation', readonly UpdateDefaultSendingOfAlertsAndReportsToUser: { readonly __typename?: 'BasicMutationResult', readonly query: { readonly __typename?: 'Query', readonly user: { readonly __typename?: 'User', readonly id: string, readonly legacyId: string, readonly websiteEmailSettings: ReadonlyArray<{ readonly __typename?: 'WebsiteEmailSettings', readonly alertEmailsSetup: GraphQL.AlertEmailsSetup, readonly isWeeklyReportEnabled: boolean, readonly websiteId: CK.WebsiteId }> } | null, readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId, readonly websitesAlerts: ReadonlyArray<{ readonly __typename?: 'WebsitesAlerts', readonly websiteId: CK.WebsiteId, readonly alerts: boolean, readonly reports: boolean }> } | null } } };

export type WebsiteReportsDefaultAlertsFormQueryVariables = GraphQL.Exact<{
  userId: GraphQL.Scalars['UserId']['input'];
  accountId: GraphQL.Scalars['AccountId']['input'];
}>;


export type WebsiteReportsDefaultAlertsFormQuery = { readonly __typename?: 'Query', readonly user: { readonly __typename?: 'User', readonly id: string, readonly legacyId: string, readonly memberships: ReadonlyArray<{ readonly __typename?: 'AccountMembership', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId }, readonly user: { readonly __typename?: 'User', readonly id: string, readonly legacyId: string }, readonly websites: ReadonlyArray<{ readonly __typename?: 'Website', readonly displayName: string, readonly id: CK.WebsiteId }> }> } | null, readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId, readonly websitesAlerts: ReadonlyArray<{ readonly __typename?: 'WebsitesAlerts', readonly websiteId: CK.WebsiteId, readonly alerts: boolean, readonly reports: boolean }> } | null };


export const UpdateDefaultSendingOfAlertsAndReportsToUserDocument = gql`
    mutation UpdateDefaultSendingOfAlertsAndReportsToUser($userId: UserId!, $accountId: AccountId!, $websites: [UpdateDefaultSendingOfAlertsAndReportsToUserWebsite!]!) {
  UpdateDefaultSendingOfAlertsAndReportsToUser(
    userId: $userId
    websites: $websites
    accountId: $accountId
  ) {
    query {
      user(uniqueId: $userId) {
        id
        legacyId
        websiteEmailSettings {
          alertEmailsSetup
          isWeeklyReportEnabled
          websiteId
        }
      }
      account(id: $accountId) {
        id
        websitesAlerts {
          websiteId
          alerts
          reports
        }
      }
    }
  }
}
    `;
export type UpdateDefaultSendingOfAlertsAndReportsToUserMutationFn = Apollo.MutationFunction<UpdateDefaultSendingOfAlertsAndReportsToUserMutation, UpdateDefaultSendingOfAlertsAndReportsToUserMutationVariables>;

/**
 * __useUpdateDefaultSendingOfAlertsAndReportsToUserMutation__
 *
 * To run a mutation, you first call `useUpdateDefaultSendingOfAlertsAndReportsToUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDefaultSendingOfAlertsAndReportsToUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDefaultSendingOfAlertsAndReportsToUserMutation, { data, loading, error }] = useUpdateDefaultSendingOfAlertsAndReportsToUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      accountId: // value for 'accountId'
 *      websites: // value for 'websites'
 *   },
 * });
 */
export function useUpdateDefaultSendingOfAlertsAndReportsToUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDefaultSendingOfAlertsAndReportsToUserMutation, UpdateDefaultSendingOfAlertsAndReportsToUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDefaultSendingOfAlertsAndReportsToUserMutation, UpdateDefaultSendingOfAlertsAndReportsToUserMutationVariables>(UpdateDefaultSendingOfAlertsAndReportsToUserDocument, options);
      }
export type UpdateDefaultSendingOfAlertsAndReportsToUserMutationHookResult = ReturnType<typeof useUpdateDefaultSendingOfAlertsAndReportsToUserMutation>;
export type UpdateDefaultSendingOfAlertsAndReportsToUserMutationResult = Apollo.MutationResult<UpdateDefaultSendingOfAlertsAndReportsToUserMutation>;
export type UpdateDefaultSendingOfAlertsAndReportsToUserMutationOptions = Apollo.BaseMutationOptions<UpdateDefaultSendingOfAlertsAndReportsToUserMutation, UpdateDefaultSendingOfAlertsAndReportsToUserMutationVariables>;
export const WebsiteReportsDefaultAlertsFormDocument = gql`
    query WebsiteReportsDefaultAlertsForm($userId: UserId!, $accountId: AccountId!) {
  user(uniqueId: $userId) {
    id
    legacyId
    memberships {
      account {
        id
      }
      user {
        id
        legacyId
      }
      websites {
        displayName
        id
      }
    }
  }
  account(id: $accountId) {
    id
    websitesAlerts {
      websiteId
      alerts
      reports
    }
  }
}
    `;

/**
 * __useWebsiteReportsDefaultAlertsFormQuery__
 *
 * To run a query within a React component, call `useWebsiteReportsDefaultAlertsFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsiteReportsDefaultAlertsFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsiteReportsDefaultAlertsFormQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useWebsiteReportsDefaultAlertsFormQuery(baseOptions: Apollo.QueryHookOptions<WebsiteReportsDefaultAlertsFormQuery, WebsiteReportsDefaultAlertsFormQueryVariables> & ({ variables: WebsiteReportsDefaultAlertsFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebsiteReportsDefaultAlertsFormQuery, WebsiteReportsDefaultAlertsFormQueryVariables>(WebsiteReportsDefaultAlertsFormDocument, options);
      }
export function useWebsiteReportsDefaultAlertsFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebsiteReportsDefaultAlertsFormQuery, WebsiteReportsDefaultAlertsFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebsiteReportsDefaultAlertsFormQuery, WebsiteReportsDefaultAlertsFormQueryVariables>(WebsiteReportsDefaultAlertsFormDocument, options);
        }
export function useWebsiteReportsDefaultAlertsFormSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebsiteReportsDefaultAlertsFormQuery, WebsiteReportsDefaultAlertsFormQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WebsiteReportsDefaultAlertsFormQuery, WebsiteReportsDefaultAlertsFormQueryVariables>(WebsiteReportsDefaultAlertsFormDocument, options);
        }
export type WebsiteReportsDefaultAlertsFormQueryHookResult = ReturnType<typeof useWebsiteReportsDefaultAlertsFormQuery>;
export type WebsiteReportsDefaultAlertsFormLazyQueryHookResult = ReturnType<typeof useWebsiteReportsDefaultAlertsFormLazyQuery>;
export type WebsiteReportsDefaultAlertsFormSuspenseQueryHookResult = ReturnType<typeof useWebsiteReportsDefaultAlertsFormSuspenseQuery>;
export type WebsiteReportsDefaultAlertsFormQueryResult = Apollo.QueryResult<WebsiteReportsDefaultAlertsFormQuery, WebsiteReportsDefaultAlertsFormQueryVariables>;